import { ReactNode, useState } from 'react';
import { Lock, ArrowUpCircle } from 'lucide-react';
import { Button } from '@pps/ui/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { PlanUpgradeDialog } from '@/components/PlanUpgradeDialog';
import { usePlanFeatures } from '@/hooks/usePlanFeatures';
import { useTranslation } from 'react-i18next';

// Só enterprise é gate válido: tier pro removido do catálogo
// (20260703150000_remove_pro_tier.sql) — features ex-pro são enterprise.
const PLAN_LEVEL: Record<string, number> = { free: 0, enterprise: 2 };

interface PlanGateProps {
  requiredPlan: 'enterprise';
  children: ReactNode;
}

export function PlanGate({ requiredPlan, children }: PlanGateProps) {
  const { level } = usePlanFeatures();
  const [upgradeOpen, setUpgradeOpen] = useState(false);
  const { t } = useTranslation();

  const requiredLevel = PLAN_LEVEL[requiredPlan] ?? 2;

  if (level >= requiredLevel) {
    return <>{children}</>;
  }

  const planName = 'Enterprise';

  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <Card className="max-w-md w-full">
        <CardContent className="flex flex-col items-center gap-4 pt-8 pb-8 text-center">
          <div className="h-16 w-16 rounded-full bg-muted flex items-center justify-center">
            <Lock className="h-8 w-8 text-muted-foreground" />
          </div>
          <h2 className="text-xl font-semibold text-foreground">
            {t('planGate.title')} — {planName}
          </h2>
          <p className="text-sm text-muted-foreground">
            {t('planGate.description', { plan: planName })}
          </p>
          <Button onClick={() => setUpgradeOpen(true)} className="gap-2 mt-2">
            <ArrowUpCircle className="h-4 w-4" />
            {t('planGate.upgradeCta')}
          </Button>
        </CardContent>
      </Card>
      <PlanUpgradeDialog open={upgradeOpen} onOpenChange={setUpgradeOpen} />
    </div>
  );
}
